import { clearLocalStorageOnInstallRoute } from '@utils/clearLocalStorageOnInstallRoute'

clearLocalStorageOnInstallRoute()
